import useWalletConnector from '@/src/components/AppComponents/WalletConnector/useWalletConnector';
import { Button } from '@/src/components/Commons/Button';
import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { FundWithDetailsEntity } from '@/src/lib/MayzSmartDB';
import { useTokensStore } from '@/src/store';
import { hexToStr } from '@/src/lib/MayzSmartDB';
import { showToken_Amount_NotRounded, showToken_Amount_Rounded } from '@/src/store/global/tokensStoreModelHelpers';

interface BtnConfirmationProps {
    isDeposit: boolean;
    fund: FundWithDetailsEntity;
    isTokensStoreReady: boolean;
    isAddingTokens: boolean;
    inputFT: bigint;
    isValidTx: boolean;
    isProcessingTx: boolean;
    setShowProcessingTx: (show: boolean) => void;
    setShowUserConfirmation: (show: boolean) => void;
    showUTxOError?: boolean;
    isProcessingArrangeUTxOTx?: boolean;
    handleBtnArrangeUTxO?: () => void;
}

export default function BtnConfirmation(props: BtnConfirmationProps) {
    //--------------------------------------
    const { walletStore } = useWalletConnector();
    //--------------------------------------
    const tokensStore = useTokensStore();
    //--------------------------------------
    const {
        isDeposit,
        fund,
        isTokensStoreReady,
        isAddingTokens,
        inputFT,
        isValidTx,
        isProcessingTx,
        setShowProcessingTx,
        setShowUserConfirmation,
        showUTxOError,
        isProcessingArrangeUTxOTx,
        handleBtnArrangeUTxO,
    } = props;
    //--------------------------------------
    return (
        <>
            {walletStore.isConnected === true ? (
                isTokensStoreReady === true && isAddingTokens === false && walletStore.isWalletDataLoading === false ? (
                    <>
                        {isDeposit === true ? (
                            <Button
                                mode="filled"
                                disabled={isValidTx === false}
                                arrow={false}
                                onClick={() => {
                                    isProcessingTx === true
                                        ? setShowProcessingTx(true)
                                        : showUTxOError === true && handleBtnArrangeUTxO !== undefined
                                        ? isProcessingArrangeUTxOTx === false
                                            ? handleBtnArrangeUTxO()
                                            : null
                                        : setShowUserConfirmation(true);
                                }}
                            >
                                {isProcessingTx === true || isProcessingArrangeUTxOTx === true ? (
                                    <>
                                        <LoaderButton classNameStyle={'black'} />
                                        PROCESSING...
                                    </>
                                ) : (
                                    `MINT ${showToken_Amount_Rounded(tokensStore, inputFT, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}`
                                )}
                            </Button>
                        ) : (
                            <Button
                                mode="filled"
                                disabled={isValidTx === false}
                                arrow={false}
                                onClick={() => {
                                    isProcessingTx === true
                                        ? setShowProcessingTx(true)
                                        : showUTxOError === true && handleBtnArrangeUTxO !== undefined
                                        ? isProcessingArrangeUTxOTx === false
                                            ? handleBtnArrangeUTxO()
                                            : null
                                        : setShowUserConfirmation(true);
                                }}
                            >
                                {isProcessingTx === true || isProcessingArrangeUTxOTx === true ? (
                                    <>
                                        <LoaderButton classNameStyle={'black'} />
                                        PROCESSING...
                                    </>
                                ) : (
                                    `REDEEM ${showToken_Amount_Rounded(tokensStore, inputFT, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}`
                                )}
                            </Button>
                        )}
                    </>
                ) : (
                    <Button mode="filled" disabled={true} arrow={false}>
                        <LoaderButton classNameStyle={'black'} />
                        LOADING...
                    </Button>
                )
            ) : (
                <Button mode="filled" disabled={true} arrow={false}>
                    CONNECT WALLET TO {isDeposit ? `MINT ${hexToStr(fund.fdFundFT_TN_Hex)}` : `REDEEM ${hexToStr(fund.fdFundFT_TN_Hex)}`}
                </Button>
            )}
        </>
    );
}
